import React, { useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { createCheckoutSession } from "../utils/paymentApi";
import { Spinner } from "./components/Spinner";

export const PaymentCancel = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const [retrying, setRetrying] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const orderId = searchParams.get("order_id");
  const lastPreviewPath = localStorage.getItem("lastPreviewPath");

  const handleGoBack = () => {
    if (lastPreviewPath) {
      navigate(lastPreviewPath);
    } else {
      navigate("/");
    }
  };

  const handleRetry = async () => {
    if (!orderId) {
      setError("No order found. Please start a new upload.");
      return;
    }

    setRetrying(true);
    setError(null);

    try {
      const { session_url } = await createCheckoutSession(orderId);
      window.location.href = session_url;
    } catch (e: any) {
      console.error("Retry checkout failed", e);
      setError("Could not restart payment. Please try again.");
      setRetrying(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center px-6 mt-12">
      <h2 className="text-xl font-bold">Payment Cancelled</h2>
      <p className="text-center mt-4 text-grayish">
        Your payment was not completed. You can retry or go back to your photo.
      </p>

      {error && <p className="text-red-500 mt-4 text-center">{error}</p>}

      <div className="flex flex-col gap-4 mt-6">
        {orderId && (
          <button
            className="bg-primary text-white px-6 py-3 rounded-lg font-bold"
            onClick={handleRetry}
            disabled={retrying}
          >
            {retrying ? <Spinner /> : "Retry Payment"}
          </button>
        )}
        <button
          className="text-primary underline"
          onClick={handleGoBack}
        >
          Go back to photo
        </button>
      </div>
    </div>
  );
};

